export const TK_PREFIX = 'playtech.mobile.';
export const EMPTY_TRANSLATION_VALUE = '[EMPTY]';
